<template>
    <div class="page-search-widget">
        <div class="search-component page-search-widget__content">
            <slot></slot>
            <search-widget @shownselector="(s) => $emit('shownselector', s)" :queryParams="queryParams" :set-departure-airport="departureAirport" :set-destination-airport="destination" :use-noscroll="useNoscroll"></search-widget>
        </div>
    </div>
</template>

<script type="text/javascript">
    import SearchWidget from './search-widget.vue';

    export default {
        props: {
            destination: {type: String, default: null},
            departureAirport: {type: String, default: null},
            useNoscroll: {type: Boolean, default: true},
            queryParams: {type: Object, default: () => ({})}
        },
        components: {
            'search-widget': SearchWidget
        }
    }
</script>